import React, { useState, useEffect } from "react";
import clinicService from "../../../../../services/clinic.service";
import ListSpan from "../common/ListSpan";
import ClinicUserReminderSettingsForm from "./ClinicUserReminderSettingsForm";
import { useEyeconxStore } from "../../../../../store/eyeconxStore";
import { useParams } from "react-router-dom";
import Loading from "../../../../common/Loading";
import userService from "../../../../../services/user.service";
const UserReminderTab = () => {
  //const site = useSelector((state)=>state.site)
  //const clinicId = site.clinicId
  //const user= site.user
  //const userId = site.user.ID

  const { clinicId } = useParams();
  const [user,setUser] = useState(null);
 
  const [reminderSettings, setReminderSettings] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const selecteduser = useEyeconxStore((state) => state.selectedUser);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setUser(selecteduser)
    getUserReminder()
  }, [selecteduser]);

  const getUserReminder = ()=>{
    userService
    .getUserReminderSettings(clinicId, selecteduser.id)
    .then((res) => {
      setLoading(false);
      setReminderSettings(res.data);
     
    })
    .catch((err) => {
      setLoading(false);
      console.log("Error");
    });
  }
  const updateReminderSettings = (newSettings)=>{
    setReminderSettings(newSettings)
  }
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title">
          Reminder Settings for {selecteduser.firstName} {selecteduser.lastName}{" "}
        </h5>
        <div>
          {isEditing ? (
            <button
              className="btn btn-secondary btn-sm mt-2"
              onClick={() => setIsEditing(false)}
            >
              <i className="bi bi-x-square bi-sm"></i> Cancel
            </button>
          ) : (
            <button
              className="btn btn-secondary btn-sm mt-2"
              onClick={() => setIsEditing(true)}
            >
              <i className="bi bi-pencil-square bi-sm"></i> Edit
            </button>
          )}
        </div>
      </div>
      <div className="row">
        {loading ? (
         <Loading/>
        ) : isEditing ? (
          <ClinicUserReminderSettingsForm
            reminderSettings={reminderSettings}
            user={user}
            updateSettings = {updateReminderSettings}
          />
        ) : (
          <>
            <div className="col-md-6">
              <ul className="list-group-flush">
                <ListSpan
                  value={reminderSettings.apptReminder}
                  text="Appointment Reminder"
                />
                <ListSpan
                  value={reminderSettings.isPrebookedReminder}
                  text="Prebooked Reminder"
                />

                <ListSpan
                  value={reminderSettings.isFirstReminder}
                  text="First Reminder"
                />
                <ListSpan
                  value={reminderSettings.isSecondReminder}
                  text="Second Reminder"
                />
                <ListSpan
                  value={reminderSettings.isLastReminder}
                  text="Last Reminder"
                />
                <ListSpan
                  value={reminderSettings.isSameDayReminder}
                  text="Same Day Reminder"
                />
                <ListSpan
                  value={reminderSettings.isClReminder}
                  text="Contact Lens Reminder"
                />
                <ListSpan
                  value={reminderSettings.isClReorder}
                  text="Contact Lens Reorder"
                />
                <ListSpan
                  value={reminderSettings.isBirthday}
                  text="Birthday Reminder"
                />
                <ListSpan
                  value={reminderSettings.isThankyou}
                  text="Thank You Reminder"
                />
                <ListSpan
                  value={reminderSettings.isWelcome}
                  text="Welcome Reminder"
                />
                <ListSpan
                  value={reminderSettings.isEmail}
                  text="Email Reminder"
                />
                <ListSpan value={reminderSettings.isSms} text="Sms Reminder" />
                <ListSpan
                  value={reminderSettings.isCall}
                  text="Call Reminder"
                />
                <ListSpan
                  value={reminderSettings.apptSummary}
                  text="Appointment Summary"
                />
                <ListSpan
                  value={reminderSettings.isClGlSummary}
                  text="Contact Lens & Glass Summary"
                />
              </ul>
            </div>
            <div className="col-md-6">
              <p>
                Reminder Time:<strong> {reminderSettings.reminderTime}</strong>
              </p>
              <p>
                Same Day Reminder Time:{" "}
                <strong>{reminderSettings.sameDayReminderTime}</strong>
              </p>
              <p>
                Days to Send Prebook Reminder:{" "}
                <strong>{reminderSettings.daysPrebookReminder}</strong>
              </p>
              <p>
                Days to Send First Reminder:{" "}
                <strong>{reminderSettings.daysFirstReminder}</strong>
              </p>
              <p>
                Days to Send Second Reminder:{" "}
                <strong>{reminderSettings.daysSecondReminder}</strong>
              </p>
              <p>
                Minutes Earlier :{" "}
                <strong>{reminderSettings.minutesToAppt} mins</strong>
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UserReminderTab;
